<template>
    <div class="header">
        <header class="navbar">
            <section class="navbar-section">
                <default-button
                    v-if="is_at_least_administrator"
                    flavor="link"
                    @click.prevent="$emit('navigate', null)"
                >
                    <app-icon glyph="menu" />
                </default-button>
                <default-button
                    v-if="!!app_context && !!app_context.settings && app_context.settings.bug_reporter_active && (!!profile_id || isPublicPage)"
                    flavor="link"
                    class="show-sm"
                    @click.prevent="bug_report"
                >
                    <app-icon glyph="bug" />
                </default-button>
                <master-search-box
                    v-if="is_at_least_administrator"
                    :class="{ 'ml-12': !$mq.match(/^(xs|sm|md)$/i) }"
                />
            </section>
            <section class="navbar-center">
                <base-link
                    :href="{ name: 'home' }"
                    @click.native="$emit('navigate', false)"
                >
                    <app-logo />
                </base-link>
            </section>
            <section class="navbar-section">
                <default-button
                    v-if="!!app_context && !!app_context.settings && app_context.settings.bug_reporter_active && (!!profile_id || isPublicPage)"
                    flavor="link"
                    class="hide-sm"
                    @click.prevent="bug_report"
                >
                    <app-icon glyph="bug" />
                </default-button>
                <default-button
                    v-if="!!profile_id"
                    flavor="link"
                    :title="translate('Logout')"
                    @click.prevent="logout"
                >
                    <app-icon glyph="log-out" />
                </default-button>
                <default-button
                    v-else-if="!profile_id"
                    flavor="link"
                    :title="translate('Login/Signup')"
                    @click.prevent="login"
                >
                    <app-icon glyph="log-in" />
                </default-button>
                <base-link
                    :href="{ name: 'profile' }"
                    class="btn btn-link"
                >
                    <figure v-if="is_at_least_administrator" class="avatar avatar-sm">
                        <app-icon v-if="!profile_id||(!!profile&&!profile.avatar)" glyph="user" />
                        <img v-else :src="profile.avatar" :alt="profile.name">
                    </figure>
                    <img v-else :src="profile.avatar" :alt="profile.name">
                </base-link>
            </section>
        </header>
    </div>
</template>

<script>
import { profile_utilities } from "@/nibnut/mixins"

import { AppLogo, DefaultButton, BaseLink, AppIcon } from "@/nibnut/components"
import { MasterSearchBox } from "@/custom/components"

export default {
    mixins: [profile_utilities],
    components: {
        AppLogo,
        DefaultButton,
        BaseLink,
        AppIcon,
        MasterSearchBox
    },
    methods: {
        bug_report () {
            this.$emit("bug-report")
        },
        login () {
            this.$store.dispatch("REQUEST_LOGIN", { panel_id: true })
        },
        logout () {
            this.$store.dispatch("LOGOUT")
        }
    },
    props: {
        isPublicPage: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
@import "./assets/sass/variables";

.header {
    .navbar-section:first-child {
        padding-left: 0.3rem;
    }
    .btn {
        border: 0;
        border-top: 3px solid transparent;

        &:focus,
        &:active,
        &.active {
            border-color: $link-color;
        }
        @include hover-supported {
            border-color: $link-color;
        }

        i {
            font-size: 1rem;
        }
        & > img {
            max-height: 1rem;
        }
    }
}
</style>
